/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.2.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  NextPortCluster,
  NextportArrivalsClusterGet200Response,
  NextportBlacklistGet200Response,
  NextportClusterGet200Response,
} from '../models';
import {
    NextPortClusterFromJSON,
    NextPortClusterToJSON,
    NextportArrivalsClusterGet200ResponseFromJSON,
    NextportArrivalsClusterGet200ResponseToJSON,
    NextportBlacklistGet200ResponseFromJSON,
    NextportBlacklistGet200ResponseToJSON,
    NextportClusterGet200ResponseFromJSON,
    NextportClusterGet200ResponseToJSON,
} from '../models';

export interface NextportArrivalsClusterGetRequest {
    cluster: string;
}

export interface NextportBlacklistImoClusterDeleteRequest {
    imo: number;
    cluster: string;
}

export interface NextportBlacklistImoClusterPutRequest {
    imo: number;
    cluster: string;
}

export interface NextportClusterClusterDeleteRequest {
    cluster: string;
}

export interface NextportClusterClusterPutRequest {
    cluster: string;
    json: NextPortCluster;
}

export interface NextportClusterPostRequest {
    json: NextPortCluster;
}

export interface NextportShipImoGetRequest {
    imo: string;
}

/**
 * 
 */
export class NextPortApi extends runtime.BaseAPI {

    /**
     * Get the predicted values for a port cluster for NextPort.
     * Get the predicted values for a port cluster for NextPort
     */
    async nextportArrivalsClusterGetRaw(requestParameters: NextportArrivalsClusterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NextportArrivalsClusterGet200Response>> {
        if (requestParameters.cluster === null || requestParameters.cluster === undefined) {
            throw new runtime.RequiredError('cluster','Required parameter requestParameters.cluster was null or undefined when calling nextportArrivalsClusterGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/nextport/arrivals/{cluster}`.replace(`{${"cluster"}}`, encodeURIComponent(String(requestParameters.cluster))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NextportArrivalsClusterGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the predicted values for a port cluster for NextPort.
     * Get the predicted values for a port cluster for NextPort
     */
    async nextportArrivalsClusterGet(requestParameters: NextportArrivalsClusterGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NextportArrivalsClusterGet200Response> {
        const response = await this.nextportArrivalsClusterGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the list of blacklisted vessels for NextPort.
     * Get the Blacklist for NextPort
     */
    async nextportBlacklistGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NextportBlacklistGet200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/nextport/blacklist/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NextportBlacklistGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the list of blacklisted vessels for NextPort.
     * Get the Blacklist for NextPort
     */
    async nextportBlacklistGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NextportBlacklistGet200Response> {
        const response = await this.nextportBlacklistGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Remove a vessel from NextPort blacklisting
     * Remove a vessel from NextPort blacklisting
     */
    async nextportBlacklistImoClusterDeleteRaw(requestParameters: NextportBlacklistImoClusterDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.imo === null || requestParameters.imo === undefined) {
            throw new runtime.RequiredError('imo','Required parameter requestParameters.imo was null or undefined when calling nextportBlacklistImoClusterDelete.');
        }

        if (requestParameters.cluster === null || requestParameters.cluster === undefined) {
            throw new runtime.RequiredError('cluster','Required parameter requestParameters.cluster was null or undefined when calling nextportBlacklistImoClusterDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/nextport/blacklist/{imo}/{cluster}`.replace(`{${"imo"}}`, encodeURIComponent(String(requestParameters.imo))).replace(`{${"cluster"}}`, encodeURIComponent(String(requestParameters.cluster))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a vessel from NextPort blacklisting
     * Remove a vessel from NextPort blacklisting
     */
    async nextportBlacklistImoClusterDelete(requestParameters: NextportBlacklistImoClusterDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.nextportBlacklistImoClusterDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Blacklist a vessel from NextPort.
     * Blacklist a vessel from NextPort either temporarily or permanently
     */
    async nextportBlacklistImoClusterPutRaw(requestParameters: NextportBlacklistImoClusterPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.imo === null || requestParameters.imo === undefined) {
            throw new runtime.RequiredError('imo','Required parameter requestParameters.imo was null or undefined when calling nextportBlacklistImoClusterPut.');
        }

        if (requestParameters.cluster === null || requestParameters.cluster === undefined) {
            throw new runtime.RequiredError('cluster','Required parameter requestParameters.cluster was null or undefined when calling nextportBlacklistImoClusterPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/nextport/blacklist/{imo}/{cluster}`.replace(`{${"imo"}}`, encodeURIComponent(String(requestParameters.imo))).replace(`{${"cluster"}}`, encodeURIComponent(String(requestParameters.cluster))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Blacklist a vessel from NextPort.
     * Blacklist a vessel from NextPort either temporarily or permanently
     */
    async nextportBlacklistImoClusterPut(requestParameters: NextportBlacklistImoClusterPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.nextportBlacklistImoClusterPutRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a port cluster
     * Delete a port cluster
     */
    async nextportClusterClusterDeleteRaw(requestParameters: NextportClusterClusterDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.cluster === null || requestParameters.cluster === undefined) {
            throw new runtime.RequiredError('cluster','Required parameter requestParameters.cluster was null or undefined when calling nextportClusterClusterDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/nextport/cluster/{cluster}`.replace(`{${"cluster"}}`, encodeURIComponent(String(requestParameters.cluster))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a port cluster
     * Delete a port cluster
     */
    async nextportClusterClusterDelete(requestParameters: NextportClusterClusterDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.nextportClusterClusterDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update a port cluster for NextPort.
     * Update a port cluster for NextPort
     */
    async nextportClusterClusterPutRaw(requestParameters: NextportClusterClusterPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.cluster === null || requestParameters.cluster === undefined) {
            throw new runtime.RequiredError('cluster','Required parameter requestParameters.cluster was null or undefined when calling nextportClusterClusterPut.');
        }

        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling nextportClusterClusterPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.json !== undefined && requestParameters.json !== null) {
            headerParameters['json'] = String(requestParameters.json);
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/nextport/cluster/{cluster}`.replace(`{${"cluster"}}`, encodeURIComponent(String(requestParameters.cluster))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a port cluster for NextPort.
     * Update a port cluster for NextPort
     */
    async nextportClusterClusterPut(requestParameters: NextportClusterClusterPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.nextportClusterClusterPutRaw(requestParameters, initOverrides);
    }

    /**
     * List all defined clusters accessible for the user
     * List all defined clusters accessible for the user
     */
    async nextportClusterGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NextportClusterGet200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/nextport/cluster/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NextportClusterGet200ResponseFromJSON(jsonValue));
    }

    /**
     * List all defined clusters accessible for the user
     * List all defined clusters accessible for the user
     */
    async nextportClusterGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NextportClusterGet200Response> {
        const response = await this.nextportClusterGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Add a port cluster for NextPort. The port clusters are used for defining one or more ports and associate it with a name
     * Add a port cluster for NextPort
     */
    async nextportClusterPostRaw(requestParameters: NextportClusterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling nextportClusterPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.json !== undefined && requestParameters.json !== null) {
            headerParameters['json'] = String(requestParameters.json);
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/nextport/cluster/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add a port cluster for NextPort. The port clusters are used for defining one or more ports and associate it with a name
     * Add a port cluster for NextPort
     */
    async nextportClusterPost(requestParameters: NextportClusterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.nextportClusterPostRaw(requestParameters, initOverrides);
    }

    /**
     * Get the predicted values for a port cluster for NextPort.
     * Get the predicted values for a port cluster for NextPort
     */
    async nextportShipImoGetRaw(requestParameters: NextportShipImoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NextportArrivalsClusterGet200Response>> {
        if (requestParameters.imo === null || requestParameters.imo === undefined) {
            throw new runtime.RequiredError('imo','Required parameter requestParameters.imo was null or undefined when calling nextportShipImoGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/nextport/ship/{imo}`.replace(`{${"imo"}}`, encodeURIComponent(String(requestParameters.imo))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NextportArrivalsClusterGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the predicted values for a port cluster for NextPort.
     * Get the predicted values for a port cluster for NextPort
     */
    async nextportShipImoGet(requestParameters: NextportShipImoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NextportArrivalsClusterGet200Response> {
        const response = await this.nextportShipImoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
